import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import { View, Image } from '@zhike/ti-ui';
import { connect } from 'react-redux';
import { get, groupBy, values, map, cloneDeep, sortBy } from 'lodash';
import { firstUpperCase, getLogoProp } from 'utils';
import { createPromise, getToken } from 'utils/action';
import axios from 'axios';
import { getUserInfo } from 'common/apis';
import { updateUserInfo, countAccuracy, countScore,
  handleLables, handleLables2 } from './utils';
import { comment, fullComment, speakingRadar1, speakingRadar2,
  speakingPigaiResult1, speakingPigaiResult2, writingPigaiResult1, writingPigaiResult2,
  writingRadar1, writingRadar2, speakingForm1, speakingForm2, writingForm, typeFrom, ieltsLabels, toeflLabels }
  from './comment';
import RadarChat from './common/radar_chart';
import Project from './common/project';
import AccuracyTable from './common/accuracy_table';
import AccuracyRing from './common/accuracy_ring';
import ExportAnswer from './export_answer';
import styles from './styles';

// 结束
class End extends Component {
  // 参数
  static propTypes = {
    report: PropTypes.object.isRequired,
    postMachinePigai: PropTypes.func.isRequired,
    getReport: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    isFull: PropTypes.bool.isRequired,
    logo: PropTypes.object.isRequired,
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      date: '2018-5-12',
      readingArr: [],
      listeningArr: [],
      speakingArr: [],
      writingArr: [],
      totalArr: [],
      speakingStatus: '', // 口语机器批改是否完成 being 表示正在批改; succeed 表示成功；
      writingStatus: '',
      phone: '0000000',
      fullPart: 1, // 完整版测评 词汇语法 听说读写两部分
      vocabularyAccuracy: 0,
      grammarAccuracy: 0,
    };
    this.totalArr = [];
  }
  // 模块即将加载
  async componentDidMount() {
    const { report, match, isFull } = this.props;
    const { exerciseId } = match.params;
    const result = get(report, 'report');
    // 对报告页数据分组处理
    let regex = /\d{4}-\d{2}-\d{2}/;  // eslint-disable-line
    const date = get(report, 'createdAt').match(regex)[0];
    const reading = get(report, 'report.Reading');
    const listening = get(report, 'report.Listening');
    const readingLabels = reading && get(reading, 'labels');
    const listeningLabels = listening && get(listening, 'labels');
    if (isFull) {
      const vocabulary = get(report, 'report.Vocabulary'); // 词汇
      const grammar = get(report, 'report.Grammar'); // 语法
      const vocabularyAccuracy = countAccuracy(vocabulary.labels[0]) >= 0.9 ? 0.9 :
        (countAccuracy(vocabulary.labels[0]) <= 0.1 ? 0.1 : countAccuracy(vocabulary.labels[0]));
      const grammarAccuracy = countAccuracy(grammar.labels[0]) >= 0.9 ? 0.9 :
        (countAccuracy(grammar.labels[0]) <= 0.1 ? 0.1 : countAccuracy(grammar.labels[0]));
      this.setState({
        vocabularyAccuracy,
        grammarAccuracy,
      });
    }
    // 获取阅读，听力的能力标签数组
    const readingArr = readingLabels && handleLables(readingLabels, isFull);
    const listeningArr = listeningLabels && handleLables(listeningLabels, isFull);
    this.totalArr = [{
      name: 'Reading',
      score: get(result, 'Reading.score'),
    },
    {
      name: 'Listening',
      score: get(result, 'Listening.score'),
    }];
    // 获取口语与写作机批结果
    await this.getStatus(report, 'speaking');
    await this.getStatus(report, 'writing');

    // 这里需要通过 exerciseId 来获取用户的年龄字段 以及用户的手机号码
    // 获取用户UserId
    const message = await axios({
      url: getUserInfo[1],
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        From: 1,
      },
      params: {
        exerciseId,
        fields: 'background,phone',
      },
    });
    const gradeNum = get(message, 'data.data.background.grade');
    const phone = get(message, 'data.data.phone');
    this.setState({
      date,
      readingArr,
      listeningArr,
      totalArr: this.totalArr,
      gradeNum: gradeNum || 0,
      phone: (phone && phone.toString()) || '0',
    });
    const examId = get(report, 'examId');
    global.document.title = `${examId === 1 ? '托福' : '雅思'}入学测评报告页 - 智课`;
  }

  // 根据得分获取评语与建议
  getComment(examId, type) {
    const { totalArr, vocabularyAccuracy, grammarAccuracy,
      speakingArr, listeningArr, writingArr, readingArr } = this.state;
    const { isFull } = this.props;
    let score = 0;
    let stage;
    if (isFull === true && type === 'total') {
      // 完整版测评 综合评价与提升建议 需要将各个科目拼接
      const newArr = [];
      const comment = [];
      if (examId === 1) {
        newArr.push('reading', 'listening', 'speaking', 'writing');
        newArr.forEach((item, index) => {
          const { score } = totalArr.filter(item1 => item1.name === firstUpperCase(item))[0];
          let stage;
          if (index === 0) {
            stage = (score <= 30 && score >= 19) ? 'stage1' : 'stage2';
          } else if (index === 1) {
            stage = (score <= 30 && score >= 21) ? 'stage1' : 'stage2';
          } else {
            stage = (score <= 30 && score >= 20) ? 'stage1' : 'stage2';
          }
          comment.push(fullComment.toefl.total[item][stage]);
        });
      } else {
        newArr.push('listening', 'reading', 'writing', 'speaking');
        newArr.forEach(item => {
          const { score } = totalArr.filter(item1 => item1.name === firstUpperCase(item))[0];
          const stage = (score <= 9 && score >= 6) ? 'stage1' : 'stage2';
          comment.push(fullComment.ielts.total[item][stage]);
        });
      }
      const totalComment = {};
      totalComment.comment = cloneDeep(comment);
      return totalComment;
    } else if (isFull === true) {
      // 如果是词汇语法
      if (type === 'vocabulary') {
        if (vocabularyAccuracy >= 0 && vocabularyAccuracy <= 0.5) {
          stage = 'stage1';
        } else if (vocabularyAccuracy > 0.5 && vocabularyAccuracy < 0.68) {
          stage = 'stage2';
        } else if (vocabularyAccuracy >= 0.68 && vocabularyAccuracy <= 0.84) {
          stage = 'stage3';
        } else {
          stage = 'stage4';
        }
      } else if (type === 'grammar') {
        if (grammarAccuracy >= 0 && grammarAccuracy < 0.8) {
          stage = 'stage1';
        } else if (grammarAccuracy >= 0.8 && grammarAccuracy <= 1) {
          stage = 'stage2';
        }
      } else {
        const arr = examId === 1 ? toeflLabels[type] : ieltsLabels[type];
        let labelsArr;
        switch (type) {
          case 'speaking':
            labelsArr = speakingArr;
            break;
          case 'reading':
            labelsArr = readingArr;
            break;
          case 'listening':
            labelsArr = listeningArr;
            break;
          case 'writing':
            labelsArr = writingArr;
            break;
          default:
            break;
        }
        arr.map(item => {
          const arr1 = labelsArr.filter(item1 => item1.name.trim() === item.name)[0];
          if (arr1 && arr1.accuracy) {
            item.accuracy = arr1.accuracy;
          } else {
            item.accuracy = 0;
          }
          return ''
        });
        const weightLable = sortBy(arr, item => item.accuracy)[0].name;
        return fullComment[examId === 1 ? 'toefl' : 'ielts'][type][weightLable];
      }
      // 对于完整版 听说读写的部分 需要根据优先级获取建议
      return fullComment[examId === 1 ? 'toefl' : 'ielts'][type][stage];
    } else {
      // 非完整版入学测评
      if (type === 'total') {
        let totalScore = 0;
        if (examId === 1) {
          this.totalArr.forEach(item => {
            totalScore += item.score;
          });
        } else {
          this.totalArr.forEach(item => {
            totalScore += item.score;
          });
          totalScore = Math.ceil(2 * totalScore / this.totalArr.length) / 2;
        }
        score = totalScore;
      } else {
        score = totalArr.filter(item => item.name === firstUpperCase(type))[0]
        && totalArr.filter(item => item.name === firstUpperCase(type))[0].score; // eslint-disable-line
      }
      if (examId === 2) {
        // 雅思
        if (type === 'reading' || type === 'listening') {
          if (score < 5.0) {
            stage = 'stage6';
          } else if (score === 5.0) {
            stage = 'stage5';
          } else if (score === 5.5) {
            stage = 'stage4';
          } else if (score === 6.0) {
            stage = 'stage3';
          } else if (score === 6.5) {
            stage = 'stage2';
          } else if (score === 7.0) {
            stage = 'stage1';
          }
        } else if (type === 'speaking') {
          if (score === 0) {
            stage = 'stage5';
          } else if (score < 5.0) {
            stage = 'stage4';
          } else if (score >= 5.0 && score < 6.0) {
            stage = 'stage3';
          } else if (score >= 6.0 && score < 7.0) {
            stage = 'stage3';
          } else if (score === 7.0) {
            stage = 'stage1';
          }
        } else if (type === 'writing') {
          if (score === 0) {
            stage = 'stage4';
          } else if (score <= 5.0) {
            stage = 'stage3';
          } else if (score >= 5.0 && score < 6.0) {
            stage = 'stage2';
          } else if (score >= 6.0) {
            stage = 'stage2';
          }
        } else if (type === 'total') {
          if (score < 5.0) {
            stage = 'stage4';
          } else if (score === 5.0 || score === 5.5) {
            stage = 'stage3';
          } else if (score === 6.0) {
            stage = 'stage2';
          } else if (score === 6.5 || score === 7.0) {
            stage = 'stage1';
          }
        }
      } else if (type !== 'total') {
        // 托福
        if ((type === 'writing' || type === 'speaking') && score === 0) {
          stage = 'stage4';
        } else if (score <= 30 && score >= 22) {
          stage = 'stage1';
        } else if (score <= 21 && score >= 13) {
          stage = 'stage2';
        } else if (score <= 12 && score >= 0) {
          stage = 'stage3';
        }
      } else if (type === 'total') {
        if (score <= 59) {
          stage = 'stage3';
        } else if (score <= 89 && score >= 60) {
          stage = 'stage2';
        } else if (score <= 120 && score >= 90) {
          stage = 'stage1';
        }
      }
      return comment[examId === 1 ? 'toefl' : 'ielts'][type][stage];
    }
  }
  // 获取机器批改状态
  async getStatus(report, type, isFirst = true) {
    const { postMachinePigai } = this.props;
    let machineResult;
    const speaking = get(report, 'report.Speaking');
    const writing = get(report, 'report.Writing');
    if (type === 'speaking') {
      machineResult = speaking && get(speaking, 'machineResult');
    } else {
      machineResult = writing && get(writing, 'machineResult');
    }
    const result = groupBy(machineResult, 'machinePigaiStatus');
    let status;
    // 当机批状态为 'NoAnswer'(未作答), Marked(已作答), Failed(批改失败)
    const NoAnswerCount = result.NoAnswer !== undefined ? result.NoAnswer.length : 0;
    const MarkedCount = result.Marked !== undefined ? result.Marked.length : 0;
    const FailedCount = result.Failed !== undefined ? result.Failed.length : 0;
    if (FailedCount || NoAnswerCount + MarkedCount === machineResult.length) {
      status = 'succeed';
      let score = 0;
      if (type === 'speaking') {
        score = speaking.score ; // eslint-disable-line
      } else {
        score = writing.score; // eslint-disable-line
      }
      this.totalArr.push({
        name: firstUpperCase(type),
        score,
      });
      this.setState({
        totalArr: this.totalArr,
      });
      let isFail;
      if (JSON.stringify(result) === '{}') {
        isFail = true;
      } else {
        isFail = FailedCount !== 0;
      }

      // 当机批结果全部返回时，获取雷达图维度数组
      await this.getRadarData(report, type, isFail);
      // 清除5秒轮询
      if (type === 'speaking') {
        clearInterval(this.querySpeaking);
      } else {
        clearInterval(this.queryWriting);
      }
    } else if (result.Committed || result.Uncommitted) {
      status = 'being';
      if (isFirst) { this.queryMachine(type); }
      // 当机器批改的状态是Uncommitted（未提交）时, 可进行重新提交。
      if (result.Uncommitted) {
        const FailsIds = map(result.Uncommitted, 'answerId');
        if (FailsIds.length !== 0) {
          createPromise(postMachinePigai, {
            subject: type,
            answerIds: FailsIds,
          });
        }
      }
    }
    // 更新机批状态
    if (type === 'speaking') {
      this.setState({
        speakingStatus: status,
      });
    } else {
      this.setState({
        writingStatus: status,
      });
    }
  }

  // 获取 口语，写作的雷达图数据
  getRadarData(report, type, isFail) {
    const { isFull } = this.props;
    const examId = get(report, 'examId');
    const speaking = get(report, 'report.Speaking');
    const writing = get(report, 'report.Writing');
    let machineResult;
    const arr = [];
    let newArr = [];
    let arr2;
    if (type === 'speaking') {
      machineResult = speaking && get(speaking, 'machineResult');
    } else {
      machineResult = writing && get(writing, 'machineResult');
    }
    const result = groupBy(machineResult, 'machinePigaiStatus');
    if (isFail) {
      // 如果机器批改失败 雷达图各维度数据参考总分
      if (examId === 1) {
        newArr = type === 'speaking' ? speakingPigaiResult1 : writingPigaiResult1;
      } else { newArr = type === 'writing' ? writingPigaiResult2 : speakingPigaiResult2; }
      newArr.forEach(item => {
        item.score = type === 'speaking' ? speaking.score : writing.score; // eslint-disable-line
      });
    } else {
      /* eslint-disable */
      // 如果存在未作答的题目，将返回的机批纬度进行补充
      if (type === 'speaking') {
        result.NoAnswer && result.NoAnswer.forEach(item => {
          item.machinePigaiResult = {
            'SCORE_DELIVERY' : 0,
            'SCORE_LANGUAGE_USE' : 0,
            'SCORE_OVER_ALL' : 0,
            'SCORE_TOPIC_DEVELOPMENT' : 0,
          }
        })
      } else {
        result.NoAnswer && result.NoAnswer.forEach(item => {
          item.machinePigaiResult = {
            'organizationScore': 0,
            'lexicalComplexityScore': 0,
            'developmentScore': 0,
            'grammarScore': 0,
            'styleScore': 0,
          }
        })
      }
      // 生成机批各维度数据
      let form;
      if (type === 'speaking') {
        if (examId === 1) {
          form = speakingForm1;
        } else {
          form = speakingForm2;
        }
      } else {
        form = writingForm;
      }
      machineResult.forEach(item => {
        let content = item.machinePigaiResult;
        for (const key of Object.keys(content)) {
          const score = content[key]
          arr.push({
            key,
            score,
            accuracy: examId === 1 ? Math.round(score / 30 * 2) / 2 : Math.round(score / 9 * 2) / 2,
          })
        };
      });
      arr2 = groupBy(arr, 'key');
      for (const key of Object.keys(arr2)) {
        if (!form[key])
        continue;
        const name = form[key];
        const score = countScore(examId, type, arr2[key]);
        newArr.push({
          name,
          score,
        })
    }
    }
    let labels = [];
    // 口语和写作客观题 能力标签
    if (type === 'speaking') {
      labels = speaking && get(speaking, 'labels');
    } else {
      labels = writing && get(writing, 'labels');
    }
    // 将能力标签得分 与机批各维度整合；生成雷达图数据
    const arr3 = labels.length !==0 ? handleLables2(labels, examId, type, isFull) : [];
    newArr.map(item => {
      const dividend = examId === 1 ? 30 : 9;
      item.accuracy =  Math.round(item.score / dividend * 2) / 2;
    })
    arr3.forEach(item => {
      newArr.push(item);
    });
    if (type === 'speaking') {
      this.setState({
        speakingArr: newArr,
      });
    } else {
      this.setState({
        writingArr: newArr,
      });
    }
  }
  /* eslint-enable */

  // 当处于 正在提交的状态时, 每五秒查询一次报告页数据，并对结果进行更新
  queryMachine(type) {
    const { getReport, match } = this.props;
    const { exerciseId, questionId, mode } = match.params;
    if (type === 'speaking') {
      this.querySpeaking = setInterval(async () => {
        const token = getToken();
        const report = await createPromise(getReport,
          {
            exerciseId,
            token,
            questionId,
            mode,
          });
        this.getStatus(report.data, type, false);
      }, 5000);
    } else {
      this.queryWriting = setInterval(async () => {
        const token = getToken();
        const report = await createPromise(getReport,
          {
            exerciseId,
            token,
            questionId,
            mode,
          });
        this.getStatus(report.data, type, false);
      }, 5000);
    }
  }

  // 渲染 头部口语写作题总分
  renderScore(status, type, score) {
    return (
      <View className={styles.score}>
        {
          status === 'succeed' &&
          <View className={styles.scoreItem}>
            {score}
          </View>
        }
        {
          status === 'being' &&
          <View className={styles.scoreItem}>--</View>
        }
        <View className={styles.scoreTitle} >{firstUpperCase(type)}</View>
      </View>
    );
  }

  // 渲染 综合评论和提升建议
  renderComment(examId, type) {
    const { speakingStatus, writingStatus } = this.state;
    if (type === 'total') {
      return (
        <View>
          <View className={styles.commentTitle}>综合评价&nbsp;&nbsp; </View>
          <View className={styles.commentText}>
            {
              speakingStatus === 'succeed' && writingStatus === 'succeed' &&
              this.getComment(examId, type).comment.map((item, index) => (
                <div key={index} className={css(styles.contentText)}>
                  <span className={css(styles.commentIcon)} />
                  {item}
                </div>))
            }
          </View>
        </View>
      );
    }
    let content;
    if ((type === 'speaking' && speakingStatus === 'succeed') ||
    (type === 'writing' && writingStatus === 'succeed') ||
    !(type === 'speaking' || type === 'writing')) {
      content = values(this.getComment(examId, type));
    }
    return (
      <View>
        <View className={styles.area}>
          <View className={[styles.commentTitle, styles.commentTitleSingle]}>名师点评&nbsp;&nbsp;</View>
          <View
            className={[styles.commentText, styles.commentTextSingle]}
          >
            {
              ((type === 'speaking' && speakingStatus === 'succeed') ||
              (type === 'writing' && writingStatus === 'succeed') ||
              !(type === 'speaking' || type === 'writing')) &&
              get(content, `${content.length - 2}`) && get(content, `${content.length - 2}`).map((item, index) => (
                <div key={index} className={css(styles.contentText)}>
                  <span className={css([styles.commentIcon, styles.commentIconSingle])} />
                  {item}
                </div>))
            }
            {
              ((type === 'speaking' && speakingStatus === 'being') ||
              (type === 'writing' && writingStatus === 'being')) &&
              <View className={styles.noContent}>暂无内容</View>
            }
          </View>
        </View>
        <View className={styles.area}>
          <View className={[styles.commentTitle, styles.commentTitleSingle]}>提升建议&nbsp;&nbsp;</View>
          <View
            className={[styles.commentText, styles.commentTextSingle]}
          >
            {
              ((type === 'speaking' && speakingStatus === 'succeed') ||
              (type === 'writing' && writingStatus === 'succeed') ||
              !(type === 'speaking' || type === 'writing')) &&
              get(content, `${content.length - 1}`) && get(content, `${content.length - 1}`).map((item, index) => (
                <div key={index} className={css(styles.contentText)}>
                  <span className={css([styles.commentIcon, styles.commentIconSingle])} />
                  {item}
                </div>))
            }
            {
              ((type === 'speaking' && speakingStatus === 'being') ||
              (type === 'writing' && writingStatus === 'being')) &&
              <View className={styles.noContent}>暂无内容</View>
            }
          </View>
        </View>
      </View>);
  }

  // 渲染综合能力 柱状图
  renderSynthesizeGrade(totalArr, examId) {
    const readingScore = totalArr.filter(item => item.name === 'Reading')[0].score;
    const listeningScore = totalArr.filter(item => item.name === 'Listening')[0].score;
    const speakingScore = totalArr.filter(item => item.name === 'Speaking')[0].score;
    const writingScore = totalArr.filter(item => item.name === 'Writing')[0].score;
    const time = examId === 1 ? 156 / 30 : 156 / 9;
    const reading = {
      subject: 'Reading',
      score: readingScore,
      height: readingScore * time,
    };
    const speaking = {
      subject: 'Speaking',
      score: speakingScore,
      height: speakingScore * time,
    };
    const listening = {
      subject: 'Listening',
      score: listeningScore,
      height: listeningScore * time,
    };
    const writing = {
      subject: 'Writing',
      score: writingScore,
      height: writingScore * time,
    };
    const newArr = [];
    if (examId === 1) {
      newArr.push(reading, listening, speaking, writing);
    } else {
      newArr.push(listening, reading, writing, speaking);
    }
    return (
      <View className={styles.synthesizeGraph}>
        <View className={styles.rectangle} />
        {
          newArr.map((item, index) => (
            <View
              className={styles.class}
              key={index}
            >
              <View className={styles.classText}>{item.score}</View>
              <View
                className={styles.graph}
                style={{ height: `${item.height}px` }}
              />
              <View className={styles.circle} />
              <View className={styles.classText} >{item.subject}</View>
            </View>
          ))
        }
      </View>
    );
  }
  // 渲染单项分析
  renderAnalysis(examId) {
    const { readingArr, listeningArr, writingArr, speakingArr, speakingStatus, writingStatus } = this.state;
    const reading = {
      type: 'reading',
      message: readingArr,
    };
    const listening = {
      type: 'listening',
      message: listeningArr,
    };
    const speaking = {
      type: 'speaking',
      message: speakingArr,
      state: speakingStatus,
      data: speakingStatus !== 'succeed' ? (examId === 1 ? speakingRadar1 : speakingRadar2)
        : (speakingArr.length === 0 ? (examId === 1 ? speakingRadar1 : speakingRadar2) : speakingArr),
    };
    const writing = {
      type: 'writing',
      message: writingArr,
      state: writingStatus,
      data: writingStatus !== 'succeed' ? (examId === 1 ? writingRadar1 : writingRadar2) :
        (writingArr.length === 0 ? (examId === 1 ? writingRadar1 : writingRadar2) : writingArr),
    };
    const newArr = [];
    if (examId === 1) {
      newArr.push(reading, listening, speaking, writing);
    } else {
      newArr.push(listening, reading, writing, speaking);
    }
    return newArr && newArr.map((item, index) => (
      <View className={styles.reading} key={index}>
        {
          this.renderLables(item, item.type)
        }
        {
          <View className={styles.readingArea}>
            {
              this.renderComment(examId, item.type)
            }
          </View>
        }
      </View>
    ));
  }

  // 渲染单项能力分析
  renderLables(labelsArr, type) {
    const { report } = this.props;
    const examId = get(report, 'examId');
    return (
      <View
        className={styles.readingAccuracy}
        style={{ backgroundImage: `url(${require(`./assets/${type}Bg.jpg`)})` }}
      >
        <View
          className={styles.subjectTitles}
          style={(type === 'writing' || type === 'speaking') ?
          { marginBottom: '40px' } : { marginBottom: '72px' }}
        >
          <View className={styles.subjectTitleBg}>{type.toUpperCase()}</View>
          <View className={styles.subjectTitle}>{typeFrom[type]}</View>
        </View>
        {
          (type === 'writing' || type === 'speaking') &&
          <View className={styles.radarArea}>
            <RadarChat
              data={labelsArr.data} // eslint-disable-line
              width={360}
              height={300}
              rotate={(examId === 2 && type === 'speaking') ? 45 : 0}
              examId={examId}
              padding={[20, 20, 15, -3]}
            />
            {
              labelsArr.state === 'being' &&
              <View className={[styles.radar, styles.radarBeingContainer]}>
                <View className={styles.radarBeing} />
                <View className={styles.radarText}>正在批改中......</View>
              </View>
            }
          </View>
        }
        {
          (type === 'reading' || type === 'listening') &&
          <AccuracyTable
            labelsArr={labelsArr.message}
          />
        }
        {
          (type === 'vocabulary' || type === 'grammar') &&
          <View className={styles.ring}>
            <AccuracyRing
              accuracy={labelsArr}
              type={type}
            />
          </View>
        }
      </View>);
  }

  // 渲染 头部导航栏
  navigationBar() {
    // state fullPart 1,词汇语法 2, 听说读写
    const { fullPart } = this.state;
    const search = global.location.search; // eslint-disable-line
    const source = decodeURIComponent(search.match(new RegExp('[?#&]source=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const role = decodeURIComponent(search.match(new RegExp('[?#&]role=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const exerciseId = get(this.props.report, 'id');
    return (
      <View className={styles.top}>
        <View className={styles.btns}>
          <View onClick={() => this.handleFullShow(1)} className={[styles.btn, fullPart === 1 && styles.selectedBtn]}>词汇语法</View>
          <View onClick={() => this.handleFullShow(0)} className={[styles.btn, fullPart === 0 && styles.selectedBtn]}>听说读写</View>
        </View>
        {
          role === 'teacher' &&
          <ExportAnswer exerciseId={exerciseId} isFull={this.props.isFull} />
        }
      </View>);
  }

  handleFullShow(value) {
    const { fullPart } = this.state;
    if (fullPart !== value) {
      this.setState({ fullPart: value });
    }
  }
  // 完整版测评词汇语法部分
  renderFullPart1() {
    const { report } = this.props;
    const { vocabularyAccuracy, grammarAccuracy } = this.state;
    const examId = get(report, 'examId');
    return (
      <View>
        <View className={styles.reading}>
          {this.renderLables(vocabularyAccuracy, 'vocabulary')}
          <View className={styles.readingArea}>
            {this.renderComment(examId, 'vocabulary')}
          </View>
        </View>
        <View className={styles.reading}>
          {this.renderLables(grammarAccuracy, 'grammar')}
          <View className={styles.readingArea}>
            {this.renderComment(examId, 'grammar')}
          </View>
        </View>
      </View>);
  }

  // 渲染
  render() {
    const { readingArr, listeningArr, totalArr,
      date, speakingStatus, writingStatus, phone, gradeNum, fullPart } = this.state;
    const search = global.location.search; // eslint-disable-line
    const product = decodeURIComponent(search.match(new RegExp('[?#&]product=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const source = decodeURIComponent(search.match(new RegExp('[?#&]source=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const role = decodeURIComponent(search.match(new RegExp('[?#&]role=([^?#&]+)', 'i')) ? RegExp.$1 : '');
    const { report, isFull, logo } = this.props;
    const examId = get(report, 'examId');
    const exerciseId = get(report, 'id');
    const readingScore = totalArr.length !== 0 && totalArr.filter(item => item.name === 'Reading')[0].score;
    const listeningScore = totalArr.length !== 0 && totalArr.filter(item => item.name === 'Listening')[0].score;
    const speakingScore = totalArr.length !== 0 && totalArr.filter(item => item.name === 'Speaking')[0] && totalArr.filter(item => item.name === 'Speaking')[0].score;
    const writingScore = totalArr.length !== 0 && totalArr.filter(item => item.name === 'Writing')[0] && totalArr.filter(item => item.name === 'Writing')[0].score;
    // 计算总分
    let totalScore = 0;
    let grade;
    let score;
    if (speakingStatus === 'succeed' && writingStatus === 'succeed') {
      if (examId === 1) {
        this.totalArr.forEach(item => {
          totalScore += item.score;
        });
      } else {
        this.totalArr.forEach(item => {
          totalScore += item.score;
        });
        totalScore = Math.ceil(2 * totalScore / this.totalArr.length) / 2;
      }
      if (!isFull) {
        const userInfo = updateUserInfo(gradeNum, totalScore, examId);
        grade = get(userInfo, 'grade');
        score = get(userInfo, 'score');
      }
    }
    const logoProp = getLogoProp({ image: logo.data.image, styles });
    return (
      <View
        className={styles.container}
        style={product ? { paddingBottom: '120px' } : { paddingBottom: '60px' }}
      >
        <View className={styles.header}>
          <View className={styles.headerTitle} >
            <Image {...logoProp} />
          </View>
          <Image src={require(`./assets/title_${examId === 1 ? 'toefl' : 'ielts'}.png`)} className={styles.title} />
          <View className={styles.date}>{date}</View>
          <View className={styles.surveyContainer}>
            <View className={styles.scores}>
              <View className={styles.score}>
                <View className={styles.scoreItem}>
                  {
                    speakingStatus === 'succeed' && writingStatus === 'succeed' ?
                    totalScore : '--'
                  }
                </View>
                <View className={styles.scoreTitle} >Total Score</View>
              </View>
              <View className={styles.interval} />
              <View className={styles.score}>
                <View className={styles.scoreItem}>
                  {examId === 1 ? readingScore : listeningScore}
                </View>
                <View className={styles.scoreTitle} > {examId === 1 ? 'Reading' : 'Listening'}</View>
              </View>
              <View className={styles.interval} />
              <View className={styles.score}>
                <View className={styles.scoreItem}>
                  {examId === 1 ? listeningScore : readingScore}
                </View>
                <View className={styles.scoreTitle} >{examId === 1 ? 'Listening' : 'Reading'}</View>
              </View>
              <View className={styles.interval} />
              {examId === 1 ? this.renderScore(speakingStatus, 'speaking', speakingScore) : this.renderScore(writingStatus, 'writing', writingScore)}
              <View className={styles.interval} />
              {examId === 1 ? this.renderScore(writingStatus, 'writing', writingScore) : this.renderScore(speakingStatus, 'speaking', speakingScore) }
            </View>
          </View>
          <View className={styles.tips}>Tips：口语和写作得分为智课AI机器人批改结果，分数仅供参考</View>
          {
            speakingStatus === 'succeed' && writingStatus === 'succeed' ?
            (
              <View className={styles.synthesize}>
                {
                  this.renderSynthesizeGrade(totalArr, examId)
                }
                <View className={styles.synthesizeEvaluate}>
                  { this.renderComment(examId, 'total') }
                </View>
              </View>)
            : (<View className={styles.being}>正在批改中，请稍候……</View>)
          }
        </View>
        {
          isFull !== true &&
          <View className={styles.singleAnalysis}>
            <View
              className={styles.singleTitle}
            >
              单项分析
            </View>
            {
              role === 'teacher' &&
              <ExportAnswer exerciseId={exerciseId} className={styles.exportAnswerTop} />
            }
            {
              readingArr.length > 0 &&
              listeningArr.length > 0 &&
              this.renderAnalysis(examId)
            }
          </View>
        }
        {
          isFull === true &&
          <View className={styles.singleAnalysis}>
            { this.navigationBar()}
            {
              fullPart === 1 &&
              this.renderFullPart1()
            }
            {
              fullPart === 0 &&
              readingArr.length > 0 &&
              listeningArr.length > 0 &&
              this.renderAnalysis(examId)
            }
          </View>
        }
        {
          !product && isFull !== true &&
          speakingStatus === 'succeed' && writingStatus === 'succeed' &&
          <Project
            examId={examId}
            grade={grade}
            score={score}
            phone={phone}
          />
        }
        {/* {
          product && isFull !== true &&
          speakingStatus === 'succeed' && writingStatus === 'succeed' &&
          <View className={styles.projectForPorduct}>
            <View className={styles.bgForPorduct}>
              <View className={styles.contentForPorduct}>
                <Image src={require('./assets/xiaozhi.png')} className={styles.xiaozhi} />
                <View className={styles.projectContent}>
                  <Image src={require('./assets/project.png')} className={styles.project} />
                  <View className={styles.textForPorduct}>
                    扫码加助教老师微信，回复<span className={css(styles.tip)}>“{examId === 1 ? '托福' : '雅思'}报告”</span>领取，有效期：自报告生成后
                    <span className={css(styles.tip)}>5天内</span>
                  </View>
                </View>
              </View>
              <Image src={require(`./assets/code_${examId === 1 ? 'toefl' : 'ielts'}.jpg`)} className={styles.code} />
            </View>
          </View>
        } */}
      </View>
    );
  }
}

export default connect(state => ({ logo: state.logo }))(End);



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/index.js